var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.$t(`tooltip.toolbar.${_vm.AppToolbarsIconsNames.Info}`).toString(),
  }),expression:"{\n    content: $t(`tooltip.toolbar.${AppToolbarsIconsNames.Info}`).toString(),\n  }"}],class:{
    'study-buddy-trigger': true,
    'study-buddy-trigger--disable': !_vm.enabledViaEvent && _vm.disabledPopupForPage,
  },attrs:{"data-testID":"study-buddy-trigger-btn","name":_vm.AppToolbarsIconsNames.Info,"orientation":"bottom","color":"blue"},on:{"click":_vm.emitGlobalStudyBuddyEvent}},[_vm._t("default"),_c('img',{attrs:{"src":"/images/icons/info.png","alt":"Info Icon"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }